/**
   * Cart Toggle (Mobile) and Cart Sections (desktop)
   * ************************************************
   * Add cookies on 1st cartCTA click to control if to open #purchaseModal popup
   */
if (purchaseModalOpenOnce == true) {
	const cartCTA = $('.btn.cta[data-toggle]');

	if (!$.cookie('cartCTAClicked')) {
		$(cartCTA).on('click', function () {
			// console.log('CartCTA clicked');

			$.cookie("cartCTAClicked", 1); //- expire per session

			setTimeout(function () {
				cartCTA.attr('data-toggle', 'false');

			}, 500);
		});

	} else {
		cartCTA.attr('data-toggle', 'false');

	}
}

/**
 * Purchase Badges Content
 * 
 * If text, calculate discount value based on: 
 * = Retail Price of Selected Unit - (Retail Price of 1 Unit * Free Units value) - Final Price of Selected Unit
 * For 6 Units: 299.70 - 49.95 * 2 - 179.95 = 19.85 (-$20)   
 * 
 * If Image: Replace img[src]
 * 
 * Loop over badges and replace relevant DOM elements
 */
function purchaseBadges(parent, product, retail, price) {
	let badgeOne = {
			parent: parent,
			wrap: $('.purchase-badges li[data-badgeid="badge1"]'),
			title: product.attr('data-purchase-badge-one-title'),
			titleSubscribe: product.attr('data-purchase-badge-one-title-subscribe'),
			content: product.attr('data-purchase-badge-one-content'),
			image: product.attr('data-purchase-badge-one-image'),
			imageSubscribe: product.attr('data-purchase-badge-one-image-subscribe')
		},
		badgeTwo = {
			parent: parent,
			wrap: $('.purchase-badges li[data-badgeid="badge2"]'),
			title: product.attr('data-purchase-badge-two-title'),
			titleSubscribe: product.attr('data-purchase-badge-two-title-subscribe'),
			content: product.attr('data-purchase-badge-two-content'),
			image: product.attr('data-purchase-badge-two-image'),
			imageSubscribe: product.attr('data-purchase-badge-two-image-subscribe')
		},
		badgeThree = {
			parent: parent,
			wrap: $('.purchase-badges li[data-badgeid="badge3"]'),
			title: product.attr('data-purchase-badge-three-title'),
			titleSubscribe: product.attr('data-purchase-badge-three-title-subscribe'),
			content: product.attr('data-purchase-badge-three-content'),
			image: product.attr('data-purchase-badge-three-image'),
			imageSubscribe: product.attr('data-purchase-badge-three-image-subscribe')
		};

	const badges = [badgeOne, badgeTwo, badgeThree];

	let imgPath = 'https://dtjlhiahlv53j.cloudfront.net/assets/olive-oil/product-v03/',
		oneUnitPrice = $('.cart__product[data-units=1]').attr('data-retail'),
		freeQuantity = product.attr('data-free-units'),
		freeQuantityPrice = (oneUnitPrice * freeQuantity).toFixed(2),
		finalPrice = price,

		//- Calculate discount
		calcDiscount = (retail - freeQuantityPrice - finalPrice).toFixed(2),
		
		//- Split Discount Value for UI manipulation
		splitCalcDiscount = calcDiscount.split("."),
		calcDiscountInteger = splitCalcDiscount[0],
		calcDiscountDecimals = splitCalcDiscount[1];

	// console.log("product", product);
	// console.log("retail", retail);
	// console.log("oneUnitPrice", oneUnitPrice);
	// console.log("freeQuantityPrice", freeQuantityPrice);
	// console.log("finalPrice", finalPrice);

	// console.log('calcDiscount', calcDiscount);

	for (const badge of badges) {
		// console.log("parent", parent);
		// console.log('wrap', badge['wrap']);
		// console.log('title', badge['title']);
		// console.log('content', badge['content']);
		// console.log('image', badge['image']);
		// console.log('imageSubscribe', badge['imageSubscribe']);

		if (badge['title'] == '') {
			badge['wrap'].hide();
		} else {
			badge['wrap'].show();
		}

		if(parent.is('#subscribeSection') || parent.find('.summary--subscribe').length) {
			parent.find(badge['wrap']).find('.purchase-badges__title').html(badge['titleSubscribe']);
			
		} else {
			parent.find(badge['wrap']).find('.purchase-badges__title').html(badge['title']);

		}

		if (badge['wrap'].hasClass('purchase-badges__item--hasDiscount')) {
			parent.find(badge['wrap']).find('.purchase-badges__content').html('<small>-$</small>' + calcDiscountInteger + '<small>.' + calcDiscountDecimals + '</small>');
		}

		if (badge['wrap'].hasClass('purchase-badges__item--hasText')) {
			parent.find(badge['wrap']).find('.purchase-badges__content').html(badge['content']);
		}

		if (badge['wrap'].hasClass('purchase-badges__item--hasImage')) {
			if(parent.is('#subscribeSection') || parent.find('.summary--subscribe').length) {
				parent.find(badge['wrap']).find('.purchase-badges__content').attr('src', imgPath + badge['imageSubscribe']);
				
			} else {
				parent.find(badge['wrap']).find('.purchase-badges__content').attr('src', imgPath + badge['image']);

			}
		}
	}
}

/**
 * Cart Toggle Section Modes and updates each section 
 */
function activeProductToggle() {
	let thisProduct = $(this);

	let amount = thisProduct.attr('data-units'),
		price = 'data-price',
		link = 'data-link',
		ship = 'data-shipping',
		retail = 'data-retail';

	let selectedProductAmount = $('.cart-toggle #cartToggle').find(`[data-units='${amount}']`);

	/**
	 * Specific vars for Subscription Mode
	 */
	let subscriptionMode = {
		wrap: $('#subscribeSection'),
		prod: $('#subscribeSection').find(`[data-units='${amount}']`),
		param: $('#subscribeSection').find('.btn').attr('data-param'),
		modalCta: $('#subscribeButton'),
		purchasePriceModal: $('#purchaseModal').find('.amount--continuity')
	}

	/**
	 * Specific vars for Normal Mode
	 */
	let regularMode = {
		wrap: $('#regularSection'),
		prod: $('#regularSection').find(`[data-units='${amount}']`),
		param: $('#regularSection').find('.btn').attr('data-param'),
		modalCta: $('#regularButton'),
		purchasePriceModal: $('#purchaseModal').find('.amount--regular')
	}

	/**
	 * Product buttons states
	 */
	$('.cart-toggle .cart__product').removeClass('active');
	selectedProductAmount.addClass('active');

	/**
	 * Controls Product Images based on selection
	 */
	$('#orderNow').removeClass(function (index, className) {
		return (className.match(/(^|\s)cart--unit\S+/g) || []).join(' ');
	}).addClass('cart--unit' + amount);

	const carts = [subscriptionMode, regularMode];

	for (const cart of carts) {
		let savingsVal = cart['prod'].attr(retail) - cart['prod'].attr(price);
		let pricePerUnit = parseFloat(cart['prod'].attr(price) / amount).toFixed(2);

		cart['wrap'].find('.price__value').html('$' + cart['prod'].attr(price));
		cart['wrap'].find('.price-per-unit__value').html('$' + pricePerUnit);
		cart['wrap'].find('.retail__value').html('$' + cart['prod'].attr(retail));
		cart['wrap'].find('.saving__value').html('$' + parseFloat(savingsVal).toFixed(2));

		cart['wrap'].find('.shipping__value').html(cart['prod'].attr(ship));
		
		if(cart['prod'].attr(ship) == '') {
			cart['wrap'].find('.summary .shipping').css('visibility', 'hidden');

		} else {
			cart['wrap'].find('.summary .shipping').css('visibility', 'visible');

		}

		cart['wrap'].find('.btn').attr('href', (cart['prod'].attr(link) + cart['param']));

		//- handle Modal popup
		cart['purchasePriceModal'].find('.amount__value').html('$' + cart['prod'].attr(price));
		cart['modalCta'].attr('href', (cart['prod'].attr(link) + cart['param']));

		if ($('.purchase-badges').length) {
			purchaseBadges(cart['wrap'], cart['prod'], cart['prod'].attr(retail), cart['prod'].attr(price));
		}
	}
};

/**
 * Subscription Option UI and Behaviour 
 */
function cartToggleSubscriptionUI() {
	let alternativeContentValue;

	$('.subscribe-wrap').toggleClass('active');

	if ($('#cartToggle').attr('data-check') === 'un-subscribe') {
		alternativeContentValue = '';

		$('#cartToggle').attr('data-check', 'subscribe');

	} else {
		alternativeContentValue = $('#alternativeContent').attr('data-alt-content');

		$('#cartToggle').attr('data-check', 'un-subscribe');

	}

	$('#alternativeContent').html(' ' + alternativeContentValue);

	if ($('#salesBanner').length) {
		let salesBannerHeight = Math.floor($('#salesBanner').height());

		if ($('#salesBanner').hasClass('isSticky')) {
			$('html, body').animate({
				scrollTop: $("#orderNow").offset().top - salesBannerHeight
			}, 1000);
		} else {
			$('html, body').animate({
				scrollTop: $("#orderNow").offset().top
			}, 1000);
		}
	} else {
		$('html, body').animate({
			scrollTop: $("#orderNow").offset().top
		}, 1000);
	}

	//- reset subscription disclaimer checkbox
	if ($('.cart-toggle .subscribe-box__checked').hasClass('checked') && !$('#cartCTASubscribe').hasClass('disabled')) {
		$('.cart-toggle .subscribe-box__checked').removeClass('checked');
		$('#cartCTASubscribe').addClass('disabled');
		$('.cart-toggle .subscribe-box__checkbox').attr('data-checkbox', false);
	}
}

/**
 * Disclaimer Checkbox and Button disabled
 */
function cartToggleCheckbox(e) {
	e.preventDefault();

	if (!$(this).hasClass('checked')) {
		$(this).addClass('checked');
		$('#cartCTASubscribe').removeClass('disabled');
		$('.cart-toggle .subscribe-box__checkbox').attr('data-checkbox', true);

	} else {
		$(this).removeClass('checked');
		$('#cartCTASubscribe').addClass('disabled');
		$('.cart-toggle .subscribe-box__checkbox').attr('data-checkbox', false);
	}
}

$('.cart-toggle .cart__product').on('click', activeProductToggle);
$('.cart-toggle .cart__product.active').trigger("click");
$('.subscribe-wrap__option').on('click', cartToggleSubscriptionUI);
$('.cart-toggle .subscribe-box__checked').on('click', cartToggleCheckbox);
